import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const Footer = ({ config, history, googleTranslate, onTosClick, onPpClick, version, environment }) => (
  <Fragment>
    <footer className='footer p-0'>
      <div className='px-0 px-md-5 pb-5 pb-md-3'>
        <div className='col-12 col-xxl-10 offset-0 offset-xxl-1 px-0 px-md-5 px-lg-0 py-5 p-lg-5 d-flex flex-wrap text-center text-lg-left'>
          {config.footer.footer1 && <div className={`col-12 col-md-${config.footer.footer2 ? '4' : '6'} px-0 ps-md-5 py-3 py-lg-0`}>
            <div dangerouslySetInnerHTML={{ __html: config.footer.footer1 }} />
          </div>}

          {config.footer.footer2 && <div className={'col-12 col-md-4 px-0 ps-md-5 py-3 py-lg-0'}>
            <div dangerouslySetInnerHTML={{ __html: config.footer.footer2 }} />
          </div>}

          <div className={'col px-0 ps-md-5 py-3 py-lg-0'}>
            <div>
              {config.footer.footer3.isFaqVisible &&
                  <div className='mb-2'>
                    <a
                      className='text-white'
                      href='#'
                      onClick={(e) => {
                        e.preventDefault();
                        if (config.faqPage.isExternalLink) {
                          window.location = config.faqPage.externalURL;
                        } else {
                          history.push('/faq');
                        }
                      }}
                    >FAQs</a>
                  </div>
              }
              {config.footer.footer3.isRequiredDocumentVisible &&
                  <div className='mb-2'>
                    <a
                      className='text-white'
                      href='#'
                      onClick={(e) => {
                        e.preventDefault();
                        history.push('/required-documents');
                      }}>Required Documents</a>
                  </div>
              }
              {config.footer.footer3.isTOSVisible &&
                  <div className='mb-2'>
                    <a
                      className='text-white'
                      href='#'
                      onClick={(e) => {
                        e.preventDefault();
                        onTosClick();
                      }}>Terms of Service</a>
                  </div>
              }
              {config.footer.footer3.isPrivacyPolicyVisible &&
                  <div className='mb-2'>
                    <a
                      className='text-white'
                      href='#'
                      onClick={(e) => {
                        e.preventDefault();
                        onPpClick();
                      }}>Privacy Policy</a>
                  </div>
              }
              <div className='mt-2'>{googleTranslate}</div>
            </div>
          </div>

        </div>
      </div>
    </footer>
    {environment !== 'production' && <div className='footer-version'>Version {version}</div>}
  </Fragment>
);

Footer.propTypes = {
  config: PropTypes.object,
  history: PropTypes.object,
  googleTranslate: PropTypes.element,
  onTosClick: PropTypes.func,
  onPpClick: PropTypes.func,
  environment: PropTypes.string,
  version: PropTypes.string,
};

export default Footer;
